import * as tslib_1 from "tslib";
import * as React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'react-tabs';
import cx from 'classnames';
import "./Tabs.css";

var ExtendedTabs = function ExtendedTabs(_a) {
  var className = _a.className,
      deci = _a.deci,
      mini = _a.mini,
      nano = _a.nano,
      props = tslib_1.__rest(_a, ["className", "deci", "mini", "nano"]);

  var _b;

  var kind = deci && 'deci' || mini && 'mini' || nano && 'nano';
  return React.createElement(Tabs, tslib_1.__assign({
    className: cx('nx-simple-tabs-react-tabs', className, (_b = {}, _b["nx-simple-tabs-react-tabs--" + kind] = kind, _b))
  }, props));
};

ExtendedTabs.propTypes = {
  className: PropTypes.string,
  deci: PropTypes.bool,
  mini: PropTypes.bool,
  nano: PropTypes.bool
};
export default ExtendedTabs;

try {
  // @ts-ignore
  Tabs.__docgenInfo = {
    "description": "",
    "displayName": "Tabs",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": true,
        "type": {
          "name": "any"
        }
      },
      "deci": {
        "defaultValue": null,
        "description": "",
        "name": "deci",
        "required": true,
        "type": {
          "name": "any"
        }
      },
      "mini": {
        "defaultValue": null,
        "description": "",
        "name": "mini",
        "required": true,
        "type": {
          "name": "any"
        }
      },
      "nano": {
        "defaultValue": null,
        "description": "",
        "name": "nano",
        "required": true,
        "type": {
          "name": "any"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}